import React from 'react';

import ConfirmModal from '../Modals/Confirm';
import useSessionTimeout from '../../hooks/useSessionTimeout';

const SessionTimeout = () => {
  const { timeoutModalProps } = useSessionTimeout();
  return timeoutModalProps && <ConfirmModal {...timeoutModalProps} />;
};

export default SessionTimeout;
